import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getShiftNoticeTimeseriesCsv } from 'api/pulse/shiftNoticeTimeseries'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useShiftNoticeTimeseriesDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_shift_notice_timeseries', {
        filters: query,
      })
      const data = await getShiftNoticeTimeseriesCsv(query)
      fileDownload(data, 'shift_notice_timeseries.csv')
    },
  })
}
